import api from '@/services/api';
import { vehiclesPath } from '.';

export interface VehicleNameSummary {
    id: string;
    name: string;
}

export interface DerivativeNameSummary {
    id: string;
    short_name: string;
    vehicle_make_id?: string;
    vehicle_model_id?: string;
}

const paramsSerializer = {
    serialize: (params: Record<string, unknown>) => {
        const usp = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((v) => usp.append(`${key}[]`, String(v)));
            } else if (value !== undefined && value !== null) {
                usp.append(key, String(value));
            }
        });
        return usp.toString();
    },
};

const clean = (ids: string[]) => Array.from(new Set(ids.filter(Boolean))).sort();

export const fetchMakesByIds = async (ids: string[]): Promise<VehicleNameSummary[]> => {
    const unique = clean(ids);
    if (unique.length === 0) return [];
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/makes/by-ids`, {
        params: { ids: unique },
        paramsSerializer,
    });
    return response.data.data;
};

export const fetchModelsByIds = async (ids: string[]): Promise<VehicleNameSummary[]> => {
    const unique = clean(ids);
    if (unique.length === 0) return [];
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/models/by-ids`, {
        params: { ids: unique },
        paramsSerializer,
    });
    return response.data.data;
};

export const fetchDerivativesByIds = async (ids: string[]): Promise<DerivativeNameSummary[]> => {
    const unique = clean(ids);
    if (unique.length === 0) return [];
    const response = await api.get<{ data: DerivativeNameSummary[] }>(`${vehiclesPath}/derivatives/by-ids`, {
        params: { ids: unique },
        paramsSerializer,
    });
    return response.data.data;
};

export const fetchTransmissionsByIds = async (ids: string[]): Promise<VehicleNameSummary[]> => {
    const unique = clean(ids);
    if (unique.length === 0) return [];
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/transmissions/by-ids`, {
        params: { ids: unique },
        paramsSerializer,
    });
    return response.data.data;
};

export const fetchFuelTypesByIds = async (ids: string[]): Promise<VehicleNameSummary[]> => {
    const unique = clean(ids);
    if (unique.length === 0) return [];
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/fuel-types/by-ids`, {
        params: { ids: unique },
        paramsSerializer,
    });
    return response.data.data;
};

export const fetchFuelTypes = async (): Promise<VehicleNameSummary[]> => {
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/fuel-types`);
    return response.data.data;
};

export const fetchTransmissions = async (): Promise<VehicleNameSummary[]> => {
    const response = await api.get<{ data: VehicleNameSummary[] }>(`${vehiclesPath}/transmissions`);
    return response.data.data;
};
